/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export type CBQSessionDTO = {
  id: string;
  cbqExamId?: string;
  status?: string;
};

type StartCBQSessionResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: CBQSessionDTO;
};

// Pull the session id out of whatever shape the API returns it in.
const extractSession = (body: any): CBQSessionDTO | undefined => {
  const candidates = [
    body?.data,
    body,
    body?.data?.session,
    body?.session,
    Array.isArray(body?.data) ? body.data[0] : undefined,
  ];
  for (const c of candidates) {
    if (c && (c.id || c.sessionId)) {
      return { ...c, id: c.id ?? c.sessionId };
    }
  }
  return undefined;
};

// POST /cbq/sessions — begin a CBQ attempt for the authenticated student.
export const StartCBQSession = async (
  cbqExamId: string
): Promise<StartCBQSessionResponse> => {
  try {
    const response = await axios.post(`/cbq/sessions`, { cbqExamId });
    const session = extractSession(response.data);
    if (!session) {
      console.error("StartCBQSession: no id in response", response.data);
      return {
        error: {
          statusCode: 200,
          message:
            response.data?.message || "Could not read the started session.",
        },
      };
    }
    return { data: session };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
